import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import SupportTechnical from "../components/SupportTechnical";

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => ({});

const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(SupportTechnical);
const withTranslationComponent = withTranslation(["supportTechnical", "support", "common"])(connectedComponent);

export default withTranslationComponent;



// WEBPACK FOOTER //
// ./src/containers/SupportTechnical.js